import React from 'react';

interface CompactTotalAppointmentsCardProps {
  dashboardAppointments: number;
  whatsappAppointments: number;
  walkinAppointments: number;
  followupAppointments: number;
  className?: string;
}

export const CompactTotalAppointmentsCard: React.FC<CompactTotalAppointmentsCardProps> = ({
  dashboardAppointments = 0,
  whatsappAppointments = 0,
  walkinAppointments = 0,
  followupAppointments = 0,
  className = ""
}) => {
  const totalAppointments = dashboardAppointments + whatsappAppointments + walkinAppointments + followupAppointments;

  return (
    <div className={`flex items-center bg-gradient-to-br from-blue-600 to-[#779aff] text-white px-3 py-2 rounded-lg shadow-sm ${className}`}>
      <div className="flex items-center space-x-4 space-y-2">
        <div>
          <span className="text-sm font-medium">Total Appointments</span>
          <div className="text-xs font-medium opacity-65">All inclusive</div>
        </div>
        <div className="text-2xl font-bold !mt-0">
          {totalAppointments.toLocaleString()}
        </div>
      </div>
    </div>
  );
};

export default CompactTotalAppointmentsCard;
